import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
const appTree = <App />;

root.render(
  process.env.NODE_ENV === "development" ? appTree : (
    <React.StrictMode>
      {appTree}
    </React.StrictMode>
  ),
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch((error) => {
      console.error("Service worker registration failed:", error);
    });
  });
}
